import React, { useState, useEffect } from 'react';
import { fetchSiteSettings } from '../../../services/siteSettingsService';
import Icon from '../../../components/AppIcon';

const BenefitsSection = () => {
  const [siteSettings, setSiteSettings] = useState({
    inviteCodeRequired: false
  });
  const [isLoadingSettings, setIsLoadingSettings] = useState(true);

  useEffect(() => {
    const loadSiteSettings = async () => {
      try {
        const settings = await fetchSiteSettings();
        setSiteSettings({
          inviteCodeRequired: settings?.inviteCodeRequired || false
        });
      } catch (error) {
        console.error('Error loading site settings:', error);
      } finally {
        setIsLoadingSettings(false);
      }
    };

    loadSiteSettings();
  }, []);

  const benefits = [
    {
      icon: 'BookOpen',
      title: 'Comprehensive Library',
      description: 'Access our complete collection of Shakespeare plays with interactive reading tools'
    },
    {
      icon: 'Award',
      title: 'Track Your Progress',
      description: 'Earn achievements and monitor your reading journey with detailed analytics'
    },
    {
      icon: 'Users',
      title: 'Join the Community',
      description: 'Connect with other Shakespeare enthusiasts and share your insights'
    },
    {
      icon: 'Sparkles',
      title: 'Interactive Learning',
      description: 'Engage with quizzes, glossaries, and performance tools to deepen your understanding'
    }
  ];

  return (
    <div className="space-y-6">
      {!isLoadingSettings && siteSettings?.inviteCodeRequired && (
        <div className="bg-accent/10 border border-accent/30 rounded-lg p-4 mb-6">
          <div className="flex items-start gap-3">
            <Icon name="Lock" size={20} className="text-accent flex-shrink-0 mt-0.5" />
            <div>
              <h3 className="font-semibold text-accent mb-1">Invitation Only</h3>
              <p className="text-sm text-muted-foreground">
                This site is currently invitation-only and requires a six-digit code to register.
                Please contact an administrator if you need an invite code.
              </p>
            </div>
          </div>
        </div>
      )}

      <div>
        <h3 className="text-xl font-bold text-foreground mb-4">Student Benefits</h3>
        <div className="space-y-4">
          {benefits?.map((benefit, index) => (
            <div key={index} className="flex items-start gap-3 p-4 bg-surface-dark/30 rounded-lg border border-border/50 hover:border-accent/50 transition-colors duration-200">
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-accent/10 flex items-center justify-center">
                <Icon name={benefit?.icon} size={20} className="text-accent" />
              </div>
              <div className="flex-1">
                <h4 className="font-semibold text-foreground mb-1">{benefit?.title}</h4>
                <p className="text-sm text-muted-foreground">{benefit?.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="bg-gradient-to-r from-accent/10 to-accent/5 border border-accent/20 rounded-lg p-4">
        <div className="flex items-center gap-2 mb-2">
          <Icon name="Info" size={16} className="text-accent" />
          <h4 className="font-semibold text-foreground">Getting Started</h4>
        </div>
        <p className="text-sm text-muted-foreground">
          Create your free student account to begin your Shakespeare journey. 
          All features are available immediately after email confirmation.
        </p>
      </div>
    </div>
  );
};

export default BenefitsSection;